export default function PlusIcon({ width = "32", height = "32", backgroundColor = "#08F", color = "#F3F4F5" }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            aria-hidden="true"
            color={backgroundColor}
            viewBox="0 0 33 33"
        >
            <path
                fill={backgroundColor}
                d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z"
            ></path>
            <path
                fill={color}
                d="M22.224 16.889H16.89v5.333h-1.777V16.89H9.779V15.11h5.334V9.778h1.777v5.333h5.334v1.778z"
            ></path>
        </svg>
    );
}